// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VP1-3ecTGHzR3ZcxwLcurA\\=\\=>div>div{justify-content:flex-start;padding-left:4px}.VP1-3ecTGHzR3ZcxwLcurA\\=\\=>div>div>span{padding-left:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pickerOverride": "VP1-3ecTGHzR3ZcxwLcurA=="
};
module.exports = ___CSS_LOADER_EXPORT___;
